/** Pagination page number generation */
export function initPagination(): void {
  const totalEl = document.getElementById('total_pages') as HTMLInputElement | null
  const currentEl = document.getElementById('current_pages') as HTMLInputElement | null
  const baseUrlEl = document.getElementById('base_url') as HTMLInputElement | null
  const container = document.getElementById('page-link-container')

  if (!totalEl || !currentEl || !baseUrlEl || !container) return

  const total = parseInt(totalEl.value)
  const current = parseInt(currentEl.value)
  const baseUrl = baseUrlEl.value
  const limit = 3

  let html = ''

  for (let i = current - limit; i < current; i++) {
    if (i === 1) {
      html += `<a href="${baseUrl}" class="page-link page-num">1</a>`
    } else if (i > 1) {
      html += `<a href="${baseUrl}page/${i}/" class="page-link page-num">${i}</a>`
    }
  }

  html += `<span class="page-link page-num active">${current}</span>`

  for (let j = current + 1; j <= current + limit; j++) {
    if (j <= total) {
      html += `<a href="${baseUrl}page/${j}/" class="page-link page-num">${j}</a>`
    }
  }

  container.innerHTML = html
}
